// extracted by mini-css-extract-plugin
module.exports = {"title":"default_title__fWaRc","firstLevelList":"default_firstLevelList__bQOEl","firstLevel":"default_firstLevel__3d51l","initiallyOpen":"default_initiallyOpen__2fqzE"};